import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { PropertyList } from './PropertyList'
import * as styles from './TopIndex.module.scss'

import {
  Banner,
  BannerHurusatoNouzeiBig,
  BannerHurusatoNouzeiSmall,
  Hero,
  Layout,
  NavigateLinkButton,
  News,
  Notification,
  PropertySearchPanel,
  ScheduleTable,
} from '../../components'
import { ReservationButton } from '../../components/contents/ReservationButton'
import { PATH } from '../../constants'
import {
  useCreateNextPath,
  useNewsApi,
  useNotificationsApi,
  useSearchQueryParams,
} from '../../hooks'

const translateNamespace = 'components.TopIndexFrame.ScheduleTable'
const showFirstBanner = false
const showSecondBanner = false

export const TopIndexFrame = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { onCreateNextPath } = useCreateNextPath()
  const { params: queryParams } = useSearchQueryParams()
  const { i18n } = useTranslation()
  const { data: notifications } = useNotificationsApi()
  const { data: news } = useNewsApi()

  return (
    <Layout>
      <div className={styles.topBannerArea}>
        <Hero
          videoUrl={`/videos/top_movie_sp_${i18n.language}.webm`}
          className={styles.sp}
          isWebm
        />
        <Hero
          videoUrl={`/videos/top_movie_pc_${i18n.language}.mp4`}
          className={clsx(styles.pc, styles.pcHero)}
        />
        <div className={styles.propertySearchPanel}>
          <PropertySearchPanel
            showAreaSearch
            onSearch={({ areas, schedule: { endDate, startDate } = {} }) => {
              navigate(
                onCreateNextPath(PATH.search, {
                  queryParams: {
                    areas,
                    checkInDate: startDate,
                    checkOutDate: endDate,
                  },
                })
              )
            }}
          />
        </div>
        {showFirstBanner && (
          <Banner
            image="/img/banner-822.png"
            link="https://www.hkdballpark.com/news/822/"
            position={{ right: 60, bottom: 413 }}
            className={styles.bannerCardFirst}
          />
        )}
        {showSecondBanner && (
          <Banner
            image="/img/banner-864.png"
            link="https://www.hkdballpark.com/news/864/"
            position={{ right: 60, bottom: 200 }}
            className={styles.bannerCard}
          />
        )}
      </div>

      {((notifications && notifications?.length > 0) ||
        (news && news?.contentJa)) && (
        <div className={styles.notificationArea}>
          {notifications && notifications.length > 0 && (
            <Notification notifications={notifications} />
          )}
          {news && news.contentJa && <News news={news} />}
        </div>
      )}
      <div className={styles.centerArea}>
        <PropertyList />
      </div>
      <div className={styles.centerArea}>
        <div className={styles.scheduleTableArea}>
          <ScheduleTable />
        </div>
        <div className={styles.viewAvailabilityList}>
          <NavigateLinkButton
            text={t(`${translateNamespace}.viewAvailabilityList`)}
            onClick={() => {
              navigate(
                onCreateNextPath(PATH.schedule, {
                  queryParams: {
                    startDate: queryParams?.startDate ?? undefined,
                  },
                })
              )
            }}
          />
        </div>
        <div className={styles.bannerArea}>
          <div className={styles.pc}>
            <BannerHurusatoNouzeiBig />
          </div>
          <div className={styles.sp}>
            <BannerHurusatoNouzeiSmall />
          </div>
        </div>
      </div>
      <ReservationButton showFlightTicket />
    </Layout>
  )
}
